import React, {
    useState,
} from "react";

import {
    Stack,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const milestoneOptions = [
    {
        label: "Driver Registration Completed",
        value: "Driver Registration Completed",
    },
    {
        label: "KYC Submitted",
        value: "KYC Submitted",
    },
    {
        label: "Driver Approved",
        value: "Driver Approved",
    },
    {
        label: "First Delivery Completed",
        value: "First Delivery Completed",
    },
    {
        label: "Ten Deliveries Completed",
        value: "Ten Deliveries Completed",
    },
    {
        label: "Thirty Deliveries Completed",
        value: "Thirty Deliveries Completed",
    },
];

const AddCommissionRuleDrawer = ({
    isOpen,
    onClose,
    onSave,
}) => {
    const [formData, setFormData] =
        useState({
            milestone_type: "",
            amount: "",
            active: true,
            effective_from:
                new Date()
                    .toISOString()
                    .slice(0, 16),
        });

    const handleChange = (
        e
    ) => {
        const {
            name,
            value,
        } = e.target;

        setFormData(
            (prev) => ({
                ...prev,
                [name]:
                    value,
            })
        );
    };

    const handleToggle = (
        e
    ) => {
        setFormData(
            (prev) => ({
                ...prev,
                active:
                    e.target
                        .checked,
            })
        );
    };

    const handleSubmit = () => {
        onSave({
            ...formData,
            amount:
                Number(
                    formData.amount
                ),
            effective_from:
                new Date(
                    formData.effective_from
                ).toISOString(),
        });

        setFormData({
            milestone_type:
                "",
            amount: "",
            active: true,
            effective_from:
                new Date()
                    .toISOString()
                    .slice(
                        0,
                        16
                    ),
        });
    };

    return (
        <ReusableDrawer
            isOpen={
                isOpen
            }
            onClose={
                onClose
            }
            headerContent={
                <h2>
                    Add
                    Commission
                    Rule
                </h2>
            }
            bodyContent={
                <Stack
                    spacing={4}
                >
                    <ReusableInput
                        label="Milestone Type"
                        name="milestone_type"
                        value={
                            formData.milestone_type
                        }
                        onChange={
                            handleChange
                        }
                        type="select"
                        placeholder="Select milestone"
                        options={
                            milestoneOptions
                        }
                    />

                    <ReusableInput
                        label="Commission Amount (P)"
                        name="amount"
                        value={
                            formData.amount
                        }
                        onChange={
                            handleChange
                        }
                        type="number"
                        placeholder="0.00"
                    />

                    <ReusableInput
                        label="Effective From"
                        name="effective_from"
                        value={
                            formData.effective_from
                        }
                        onChange={
                            handleChange
                        }
                        type="datetime-local"
                    />

                    <ReusableInput
                        label="Active"
                        name="active"
                        value={
                            formData.active
                        }
                        onChange={
                            handleToggle
                        }
                        type="switch"
                    />
                </Stack>
            }
            footerContent={
                <Stack
                    direction="row"
                    spacing={4}
                    justifyContent="flex-end"
                >
                    <GradientButton
                        onClick={
                            onClose
                        }
                        width="100px"
                        height="40px"
                    >
                        Cancel
                    </GradientButton>

                    <GradientButton
                        onClick={
                            handleSubmit
                        }
                        width="100px"
                        height="40px"
                    >
                        Save
                    </GradientButton>
                </Stack>
            }
        />
    );
};

export default AddCommissionRuleDrawer;